import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../../contexts/AuthContext';
import { Modules, NonAuthRoutes } from '../../enums';

const RoleChangedBanner: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { roleChanged, logout } = useContext(AuthContext);

  if (!roleChanged) return null;

  const handleSignOut = async () => {
    await logout();
    navigate(Modules.auth + NonAuthRoutes.login);
  };

  return (
    <div className="alert alert-warning d-flex align-items-center justify-content-between mb-0 rounded-0" role="alert">
      <span>{t('roleChangedBanner.message')}</span>
      <button type="button" className="btn btn-warning btn-sm ms-3 text-nowrap" onClick={handleSignOut}>
        {t('roleChangedBanner.signOutNow')}
      </button>
    </div>
  );
};

export default RoleChangedBanner;
